import { render, staticRenderFns } from "./A.vue?vue&type=template&id=1746e073&scoped=true&"
import script from "./A.vue?vue&type=script&lang=js&"
export * from "./A.vue?vue&type=script&lang=js&"
import style0 from "./A.vue?vue&type=style&index=0&id=1746e073&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1746e073",
  null
  
)

export default component.exports